import { action } from 'typesafe-actions'
import { GET_TASKS_LIST, IS_TASK_LIST_LOADING, SET_TASKS_LIST } from './constants'

export const getTasksList = () => action(GET_TASKS_LIST)
export const setTasksList = (current: any) => action(SET_TASKS_LIST, current)

export const setIsTaskListLoading = (isLoading: boolean) => action(IS_TASK_LIST_LOADING, isLoading)
